import { Component, EventEmitter, Output } from '@angular/core';

interface SelectedImage {
  file: File;
  preview: string;
}

interface AttachedImage {
  filename: string;
  mimeType: string;
  data: string;
}

@Component({
  selector: 'smart-fix-image-attach-component',
  templateUrl: './smart-fix-image-attach-component.component.html',
  styleUrls: ['./smart-fix-image-attach-component.component.scss'],
})
export class SmartFixImageAttachComponent {
  selectedImages: SelectedImage[] = [];
  maxImages: number = 1;
  maxFileSize: number = 5 * 1024 * 1024; // 5MB
  enableImageAttachment: boolean = false;
  isLoading = false;
  isDragOver = false; // For drag and drop visual feedback

  @Output() imageAttachedSuccess = new EventEmitter<boolean>();
  @Output() imageAttached = new EventEmitter<SelectedImage>();

  attachImage(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files) {
      const files = Array.from(input.files);
      this.selectedImages = [];
      let processedFiles = 0;
      const totalFiles = Math.min(files.length, this.maxImages);

      if (totalFiles === 0) {
        console.log('here1');
        return;
      }

      for (const file of files) {
        if (this.selectedImages.length >= this.maxImages) {
          console.log('here2');

          break;
        }

        if (!file.type.startsWith('image/')) {
          alert('Please select only image files');
          processedFiles++;
          if (processedFiles === totalFiles) {
            this.checkAndContinue();
          }
          continue;
        }

        if (file.size > this.maxFileSize) {
          processedFiles++;
          if (processedFiles === totalFiles) {
            this.checkAndContinue();
          }
          continue;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          const preview = e.target?.result as string;
          this.selectedImages.push({
            file,
            preview,
          });

          processedFiles++;
          console.log(
            `Processed ${processedFiles}/${totalFiles} files, selectedImages length: ${this.selectedImages.length}`
          );

          if (processedFiles === totalFiles) {
            this.checkAndContinue();
          }
        };

        reader.readAsDataURL(file);
      }

      input.value = '';
    }
  }

  private checkAndContinue(): void {
    if (this.selectedImages.length > 0) {
      // this.sendImagesAndContinue(this.selectedImages);
      this.imageAttachedSuccess.emit(true);
      this.imageAttached.emit(this.selectedImages[0]);

      console.log(
        '📎 Image attached successfully via smart-fix-image-attach-component'
      );
    } else {
      this.isLoading = false;
    }
  }

  // Drag and drop functionality
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files) {
      // Create a fake event object to reuse existing attachImage logic
      const fakeEvent = {
        target: {
          files: Array.from(files),
        },
      } as any;
      this.attachImage(fakeEvent);
    }
  }
}
